import type { Immutable } from "immer";
import React from "react";

import type { HorizontalRuleBlock as HorizontalRuleBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const HorizontalRuleBlock = (
    props: Immutable<{ value: HorizontalRuleBlockValue }>,
): React.JSX.Element => {
    return (
        <hr
            className={concatClassNames([
                styles.horizontalRuleBlock,
                props.value.full_bleed ? "u-full-bleed" : null,
            ])}
        />
    );
};
